import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonLiteral1u57id0qmqut7 as JsonLiteral,
  JsonNull_getInstance1i1hv1sbjynto as JsonNull_getInstance,
  JsonPrimitive2fp8648nd60dn as JsonPrimitive,
  JsonPrimitive1xkjzc5d7ihuv as JsonPrimitive_0,
  JsonPrimitiveolttw629wj53 as JsonPrimitive_1,
  JsonArray2urf8ey7u44sd as JsonArray,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive_2,
} from '../JsonElement.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractEncoder.mjs';
import {
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl212c25g5qzedjl1 as UInt__toString_impl_dbgl21,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7k36l427nkiqphd as ULong__toString_impl_f9au7k,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg3k7aad61xjb4o as UByte__toString_impl_v72jg,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee2vx1is7vlchpz as UShort__toString_impl_edaoee,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import { NamedValueEncoder1lca9edk1lf89 as NamedValueEncoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Tagged.mjs';
import { getJsonElementName36ciq3w3g8x0l as getJsonElementName } from './JsonNamesMap.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  InvalidFloatingPointEncoded1h6zoomba5tnf as InvalidFloatingPointEncoded,
  InvalidKeyKindException3b5w96w0jjxof as InvalidKeyKindException,
} from './JsonExceptions.mjs';
import {
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/NumbersJs.mjs';
import { AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/AbstractPolymorphicSerializer.mjs';
import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  OBJECT_getInstancerq52wx6ymebx as OBJECT_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
  ENUM_getInstance25239ht7oag6o as ENUM_getInstance,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  equals2au1ep9vhcato as equals,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ClassDiscriminatorMode_NONE_getInstance30klgvxbw1mx1 as ClassDiscriminatorMode_NONE_getInstance } from '../JsonConfiguration.mjs';
import {
  classDiscriminator9fd3hvqsgfqq as classDiscriminator,
  access$checkEncodingConflicts$tPolymorphicKt2migrcemidykb as access$checkEncodingConflicts$tPolymorphicKt,
  checkKind2e7hdnuk9c0tp as checkKind,
} from './Polymorphic.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/PolymorphicSerializer.mjs';
import { SerializationStrategyh6ouydnm6hci as SerializationStrategy } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { carrierDescriptor9eih94weel9f as carrierDescriptor } from './WriteMode.mjs';
import { toString1n9qg6fb0b5i8 as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  get_isUnquotedLiteral1m5ywe5x8bka4 as get_isUnquotedLiteral,
  get_isUnsignedNumber3dxwaa3af8ncr as get_isUnsignedNumber,
} from './StreamingJsonEncoder.mjs';
import { JsonEncoder1qlse6simkfi1 as JsonEncoder } from '../JsonEncoder.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { toInt2q8uldh7sc951 as toInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  JsonArraySerializer_getInstance2u75x9rgsas6i as JsonArraySerializer_getInstance,
  JsonObjectSerializer_getInstance15ehqyi55oo4q as JsonObjectSerializer_getInstance,
} from '../JsonElementSerializers.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function writeJson(json, value, serializer) {
  var result = {_v: null};
  var encoder = JsonTreeEncoder().new_kotlinx_serialization_json_internal_JsonTreeEncoder_wuszu5_k$(json, (it) => {
    result._v = it;
    return Unit_instance;
  });
  encoder.encodeSerializableValue_3uuzip_k$(serializer, value);
  var tmp;
  if (result._v == null) {
    throwUninitializedPropertyAccessException('result');
  } else {
    tmp = result._v;
  }
  return tmp;
}
var JsonTreeEncoderClass;
function JsonTreeEncoder() {
  if (JsonTreeEncoderClass === VOID) {
    class $ extends AbstractJsonTreeEncoder() {
      constructor(json, nodeConsumer) {
        return new.target.new_kotlinx_serialization_json_internal_JsonTreeEncoder_wuszu5_k$(json, nodeConsumer);
      }
      static new_kotlinx_serialization_json_internal_JsonTreeEncoder_wuszu5_k$(json, nodeConsumer) {
        var $this = this.new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder_90zv2p_k$(json, nodeConsumer);
        var tmp = $this;
        // Inline function 'kotlin.collections.linkedMapOf' call
        tmp.content_1 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_ga0any_k$();
        return $this;
      }
      putElement_rnqfb1_k$(key, element) {
        // Inline function 'kotlin.collections.set' call
        this.content_1.put_4fpzoq_k$(key, element);
      }
      encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value) {
        if (!(value == null) || this.configuration_1.explicitNulls_1) {
          super.encodeNullableSerializableElement_5lquiv_k$(descriptor, index, serializer, value);
        }
      }
      getCurrent_z8uawt_k$() {
        return new (JsonObject())(this.content_1);
      }
    }
    initMetadataForClass($, 'JsonTreeEncoder');
    JsonTreeEncoderClass = $;
  }
  return JsonTreeEncoderClass;
}
function inlineUnsignedNumberEncoder($this, tag) {
  return AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1().new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder__no_name_provided__yu9ys_k$($this, tag);
}
function inlineUnquotedLiteralEncoder($this, tag, inlineDescriptor) {
  return AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1().new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder__no_name_provided__mjf29z_k$($this, tag, inlineDescriptor);
}
var AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1Class;
function AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1() {
  if (AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1Class === VOID) {
    class $ extends AbstractEncoder() {
      constructor(this$0, $tag) {
        return new.target.new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder__no_name_provided__yu9ys_k$(this$0, $tag);
      }
      static new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder__no_name_provided__yu9ys_k$(this$0, $tag, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        $box.$tag_1 = $tag;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
        $this.serializersModule_1 = this$0.json_1.get_serializersModule_piitvg_k$();
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      putUnquotedString_jy6tm1_k$(s) {
        return this.this$0__1.putElement_rnqfb1_k$(this.$tag_1, new (JsonLiteral())(s, false));
      }
      encodeInt_y5zi3z_k$(value) {
        // Inline function 'kotlin.toUInt' call
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(value);
        return this.putUnquotedString_jy6tm1_k$(UInt__toString_impl_dbgl21(tmp$ret$0));
      }
      encodeLong_vlw3uq_k$(value) {
        // Inline function 'kotlin.toULong' call
        var tmp$ret$0 = _ULong___init__impl__c78o9k(value);
        return this.putUnquotedString_jy6tm1_k$(ULong__toString_impl_f9au7k(tmp$ret$0));
      }
      encodeByte_6txfee_k$(value) {
        // Inline function 'kotlin.toUByte' call
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(value);
        return this.putUnquotedString_jy6tm1_k$(UByte__toString_impl_v72jg(tmp$ret$0));
      }
      encodeShort_gza6si_k$(value) {
        // Inline function 'kotlin.toUShort' call
        var tmp$ret$0 = _UShort___init__impl__jigrne(value);
        return this.putUnquotedString_jy6tm1_k$(UShort__toString_impl_edaoee(tmp$ret$0));
      }
    }
    initMetadataForClass($);
    AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1Class = $;
  }
  return AbstractJsonTreeEncoder$inlineUnsignedNumberEncoder$1Class;
}
var AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1Class;
function AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1() {
  if (AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1Class === VOID) {
    class $ extends AbstractEncoder() {
      constructor(this$0, $tag, $inlineDescriptor) {
        return new.target.new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder__no_name_provided__mjf29z_k$(this$0, $tag, $inlineDescriptor);
      }
      static new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder__no_name_provided__mjf29z_k$(this$0, $tag, $inlineDescriptor, $box) {
        if ($box === VOID)
          $box = {};
        $box.this$0__1 = this$0;
        $box.$tag_1 = $tag;
        $box.$inlineDescriptor_1 = $inlineDescriptor;
        return this.new_kotlinx_serialization_encoding_AbstractEncoder_2d7vxe_k$($box);
      }
      get_serializersModule_piitvg_k$() {
        return this.this$0__1.json_1.get_serializersModule_piitvg_k$();
      }
      encodeString_424b5v_k$(value) {
        return this.this$0__1.putElement_rnqfb1_k$(this.$tag_1, new (JsonLiteral())(value, false, this.$inlineDescriptor_1));
      }
    }
    initMetadataForClass($);
    AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1Class = $;
  }
  return AbstractJsonTreeEncoder$inlineUnquotedLiteralEncoder$1Class;
}
var AbstractJsonTreeEncoderClass;
function AbstractJsonTreeEncoder() {
  if (AbstractJsonTreeEncoderClass === VOID) {
    class $ extends NamedValueEncoder() {
      static new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder_90zv2p_k$(json, nodeConsumer) {
        var $this = this.new_kotlinx_serialization_internal_NamedValueEncoder_pcvqd2_k$();
        $this.json_1 = json;
        $this.nodeConsumer_1 = nodeConsumer;
        $this.configuration_1 = $this.json_1.configuration_1;
        $this.polymorphicDiscriminator_1 = null;
        $this.polymorphicSerialName_1 = null;
        return $this;
      }
      get_json_woos35_k$() {
        return this.json_1;
      }
      get_serializersModule_piitvg_k$() {
        return this.json_1.get_serializersModule_piitvg_k$();
      }
      elementName_p66hrm_k$(descriptor, index) {
        return getJsonElementName(descriptor, this.json_1, index);
      }
      shouldEncodeElementDefault_x8eyid_k$(descriptor, index) {
        return this.configuration_1.encodeDefaults_1;
      }
      composeName_8y2y4d_k$(parentName, childName) {
        return childName;
      }
      encodeNotNullMark_415a1t_k$() {
      }
      encodeNull_ejiosz_k$() {
        var tmp0_elvis_lhs = this.get_currentTagOrNull_yhyzw_k$();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return this.nodeConsumer_1(JsonNull_getInstance());
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tag = tmp;
        this.encodeTaggedNull_qzw0n5_k$(tag);
      }
      encodeTaggedNull_qzw0n5_k$(tag) {
        return this.putElement_rnqfb1_k$(tag, JsonNull_getInstance());
      }
      encodeTaggedNull_ef6rw0_k$(tag) {
        return this.encodeTaggedNull_qzw0n5_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
      }
      encodeTaggedInt_tkpbln_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive(value));
      }
      encodeTaggedInt_sojdj8_k$(tag, value) {
        return this.encodeTaggedInt_tkpbln_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedByte_5409y0_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive(value));
      }
      encodeTaggedByte_zfi7rb_k$(tag, value) {
        return this.encodeTaggedByte_5409y0_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedShort_wf2i94_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive(value));
      }
      encodeTaggedShort_18vuif_k$(tag, value) {
        return this.encodeTaggedShort_wf2i94_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedLong_ifi8eg_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive(value));
      }
      encodeTaggedLong_j9j45b_k$(tag, value) {
        return this.encodeTaggedLong_ifi8eg_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedFloat_4is9mw_k$(tag, value) {
        this.putElement_rnqfb1_k$(tag, JsonPrimitive(value));
        if (!this.configuration_1.allowSpecialFloatingPointValues_1 && !isFinite(value)) {
          throw InvalidFloatingPointEncoded(value, tag);
        }
      }
      encodeTaggedFloat_dhn4x5_k$(tag, value) {
        return this.encodeTaggedFloat_4is9mw_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeSerializableValue_3uuzip_k$(serializer, value) {
        if (!(this.get_currentTagOrNull_yhyzw_k$() == null) || !get_requiresTopLevelTag(carrierDescriptor(serializer.get_descriptor_wjt6a0_k$(), this.get_serializersModule_piitvg_k$()))) {
          $l$block: {
            // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
            if (this.get_json_woos35_k$().configuration_1.useArrayPolymorphism_1) {
              serializer.serialize_5ase3y_k$(this, value);
              break $l$block;
            }
            var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer();
            var tmp;
            if (isPolymorphicSerializer) {
              tmp = !this.get_json_woos35_k$().configuration_1.classDiscriminatorMode_1.equals(ClassDiscriminatorMode_NONE_getInstance());
            } else {
              var tmp_0;
              switch (this.get_json_woos35_k$().configuration_1.classDiscriminatorMode_1.ordinal_1) {
                case 0:
                case 2:
                  tmp_0 = false;
                  break;
                case 1:
                  // Inline function 'kotlin.let' call

                  var it = serializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
                  tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp = tmp_0;
            }
            var needDiscriminator = tmp;
            var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.get_descriptor_wjt6a0_k$(), this.get_json_woos35_k$()) : null;
            var tmp_1;
            if (isPolymorphicSerializer) {
              var casted = serializer instanceof AbstractPolymorphicSerializer() ? serializer : THROW_CCE();
              $l$block_0: {
                // Inline function 'kotlin.requireNotNull' call
                if (value == null) {
                  var message = 'Value for serializer ' + toString(serializer.get_descriptor_wjt6a0_k$()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
                  throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
                } else {
                  break $l$block_0;
                }
              }
              var actual = findPolymorphicSerializer(casted, this, value);
              tmp_1 = isInterface(actual, SerializationStrategy()) ? actual : THROW_CCE();
            } else {
              tmp_1 = serializer;
            }
            var actualSerializer = tmp_1;
            if (!(baseClassDiscriminator == null)) {
              access$checkEncodingConflicts$tPolymorphicKt(this.get_json_woos35_k$(), serializer, actualSerializer, baseClassDiscriminator);
              checkKind(actualSerializer.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$());
              var serialName = actualSerializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
              this.polymorphicDiscriminator_1 = baseClassDiscriminator;
              this.polymorphicSerialName_1 = serialName;
            }
            actualSerializer.serialize_5ase3y_k$(this, value);
          }
        } else {
          // Inline function 'kotlin.run' call
          JsonPrimitiveEncoder().new_kotlinx_serialization_json_internal_JsonPrimitiveEncoder_oz1h24_k$(this.json_1, this.nodeConsumer_1).encodeSerializableValue_3uuzip_k$(serializer, value);
        }
      }
      encodeTaggedDouble_wgtjw1_k$(tag, value) {
        this.putElement_rnqfb1_k$(tag, JsonPrimitive(value));
        if (!this.configuration_1.allowSpecialFloatingPointValues_1 && !isFinite_0(value)) {
          throw InvalidFloatingPointEncoded(value, tag);
        }
      }
      encodeTaggedDouble_wxqx2s_k$(tag, value) {
        return this.encodeTaggedDouble_wgtjw1_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedBoolean_hv2cld_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive_0(value));
      }
      encodeTaggedBoolean_96ly0o_k$(tag, value) {
        return this.encodeTaggedBoolean_hv2cld_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedChar_owp4mj_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive_1(toString_0(value)));
      }
      encodeTaggedChar_o52n5u_k$(tag, value) {
        return this.encodeTaggedChar_owp4mj_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedString_wkr2bh_k$(tag, value) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive_1(value));
      }
      encodeTaggedString_w0iev4_k$(tag, value) {
        return this.encodeTaggedString_wkr2bh_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedEnum_56ln9q_k$(tag, enumDescriptor, ordinal) {
        return this.putElement_rnqfb1_k$(tag, JsonPrimitive_1(enumDescriptor.getElementName_u4sqmf_k$(ordinal)));
      }
      encodeTaggedEnum_vfihkh_k$(tag, enumDescriptor, ordinal) {
        return this.encodeTaggedEnum_56ln9q_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor, ordinal);
      }
      encodeTaggedValue_sfcjfh_k$(tag, value) {
        this.putElement_rnqfb1_k$(tag, JsonPrimitive_1(toString(value)));
      }
      encodeTaggedValue_uwjsrc_k$(tag, value) {
        return this.encodeTaggedValue_sfcjfh_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), value);
      }
      encodeTaggedInline_idwvcu_k$(tag, inlineDescriptor) {
        return get_isUnsignedNumber(inlineDescriptor) ? inlineUnsignedNumberEncoder(this, tag) : get_isUnquotedLiteral(inlineDescriptor) ? inlineUnquotedLiteralEncoder(this, tag, inlineDescriptor) : super.encodeTaggedInline_k3uebz_k$(tag, inlineDescriptor);
      }
      encodeTaggedInline_k3uebz_k$(tag, inlineDescriptor) {
        return this.encodeTaggedInline_idwvcu_k$((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
      }
      encodeInline_wxp5pu_k$(descriptor) {
        var tmp;
        if (!(this.get_currentTagOrNull_yhyzw_k$() == null)) {
          if (!(this.polymorphicDiscriminator_1 == null))
            this.polymorphicSerialName_1 = descriptor.get_serialName_u2rqhk_k$();
          tmp = super.encodeInline_wxp5pu_k$(descriptor);
        } else {
          tmp = JsonPrimitiveEncoder().new_kotlinx_serialization_json_internal_JsonPrimitiveEncoder_oz1h24_k$(this.json_1, this.nodeConsumer_1).encodeInline_wxp5pu_k$(descriptor);
        }
        return tmp;
      }
      beginStructure_yljocp_k$(descriptor) {
        var tmp;
        if (this.get_currentTagOrNull_yhyzw_k$() == null) {
          tmp = this.nodeConsumer_1;
        } else {
          tmp = (node) => {
            this.putElement_rnqfb1_k$(this.get_currentTag_wui9re_k$(), node);
            return Unit_instance;
          };
        }
        var consumer = tmp;
        var tmp0_subject = descriptor.get_kind_wop7ml_k$();
        var tmp_0;
        var tmp_1;
        if (equals(tmp0_subject, LIST_getInstance())) {
          tmp_1 = true;
        } else {
          tmp_1 = tmp0_subject instanceof PolymorphicKind();
        }
        if (tmp_1) {
          tmp_0 = JsonTreeListEncoder().new_kotlinx_serialization_json_internal_JsonTreeListEncoder_ay6wlx_k$(this.json_1, consumer);
        } else {
          if (equals(tmp0_subject, MAP_getInstance())) {
            // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
            var this_0 = this.json_1;
            var keyDescriptor = carrierDescriptor(descriptor.getElementDescriptor_ncda77_k$(0), this_0.get_serializersModule_piitvg_k$());
            var keyKind = keyDescriptor.get_kind_wop7ml_k$();
            var tmp_2;
            var tmp_3;
            if (keyKind instanceof PrimitiveKind()) {
              tmp_3 = true;
            } else {
              tmp_3 = equals(keyKind, ENUM_getInstance());
            }
            if (tmp_3) {
              tmp_2 = JsonTreeMapEncoder().new_kotlinx_serialization_json_internal_JsonTreeMapEncoder_73hi4b_k$(this.json_1, consumer);
            } else {
              if (this_0.configuration_1.allowStructuredMapKeys_1) {
                tmp_2 = JsonTreeListEncoder().new_kotlinx_serialization_json_internal_JsonTreeListEncoder_ay6wlx_k$(this.json_1, consumer);
              } else {
                throw InvalidKeyKindException(keyDescriptor);
              }
            }
            tmp_0 = tmp_2;
          } else {
            tmp_0 = JsonTreeEncoder().new_kotlinx_serialization_json_internal_JsonTreeEncoder_wuszu5_k$(this.json_1, consumer);
          }
        }
        var encoder = tmp_0;
        var discriminator = this.polymorphicDiscriminator_1;
        if (!(discriminator == null)) {
          if (encoder instanceof JsonTreeMapEncoder()) {
            encoder.putElement_rnqfb1_k$('key', JsonPrimitive_1(discriminator));
            var tmp1_elvis_lhs = this.polymorphicSerialName_1;
            encoder.putElement_rnqfb1_k$('value', JsonPrimitive_1(tmp1_elvis_lhs == null ? descriptor.get_serialName_u2rqhk_k$() : tmp1_elvis_lhs));
          } else {
            var tmp2_elvis_lhs = this.polymorphicSerialName_1;
            encoder.putElement_rnqfb1_k$(discriminator, JsonPrimitive_1(tmp2_elvis_lhs == null ? descriptor.get_serialName_u2rqhk_k$() : tmp2_elvis_lhs));
          }
          this.polymorphicDiscriminator_1 = null;
          this.polymorphicSerialName_1 = null;
        }
        return encoder;
      }
      endEncode_mdsrgg_k$(descriptor) {
        this.nodeConsumer_1(this.getCurrent_z8uawt_k$());
      }
    }
    initMetadataForClass($, 'AbstractJsonTreeEncoder', VOID, VOID, [JsonEncoder()]);
    AbstractJsonTreeEncoderClass = $;
  }
  return AbstractJsonTreeEncoderClass;
}
function get_requiresTopLevelTag(_this__u8e3s4) {
  var tmp;
  var tmp_0 = _this__u8e3s4.get_kind_wop7ml_k$();
  if (tmp_0 instanceof PrimitiveKind()) {
    tmp = true;
  } else {
    tmp = _this__u8e3s4.get_kind_wop7ml_k$() === ENUM_getInstance();
  }
  return tmp;
}
var JsonPrimitiveEncoderClass;
function JsonPrimitiveEncoder() {
  if (JsonPrimitiveEncoderClass === VOID) {
    class $ extends AbstractJsonTreeEncoder() {
      constructor(json, nodeConsumer) {
        return new.target.new_kotlinx_serialization_json_internal_JsonPrimitiveEncoder_oz1h24_k$(json, nodeConsumer);
      }
      static new_kotlinx_serialization_json_internal_JsonPrimitiveEncoder_oz1h24_k$(json, nodeConsumer) {
        var $this = this.new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder_90zv2p_k$(json, nodeConsumer);
        $this.content_1 = null;
        $this.pushTag_bibnaf_k$('primitive');
        return $this;
      }
      putElement_rnqfb1_k$(key, element) {
        // Inline function 'kotlin.require' call
        if (!(key === 'primitive')) {
          var message = "This output can only consume primitives with 'primitive' tag";
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
        }
        // Inline function 'kotlin.require' call
        if (!(this.content_1 == null)) {
          var message_0 = 'Primitive element was already recorded. Does call to .encodeXxx happen more than once?';
          throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message_0));
        }
        this.content_1 = element;
        this.nodeConsumer_1(element);
      }
      getCurrent_z8uawt_k$() {
        var tmp0 = this.content_1;
        var tmp$ret$0;
        $l$block: {
          // Inline function 'kotlin.requireNotNull' call
          if (tmp0 == null) {
            var message = 'Primitive element has not been recorded. Is call to .encodeXxx is missing in serializer?';
            throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$(toString(message));
          } else {
            tmp$ret$0 = tmp0;
            break $l$block;
          }
        }
        return tmp$ret$0;
      }
    }
    initMetadataForClass($, 'JsonPrimitiveEncoder');
    JsonPrimitiveEncoderClass = $;
  }
  return JsonPrimitiveEncoderClass;
}
var JsonTreeListEncoderClass;
function JsonTreeListEncoder() {
  if (JsonTreeListEncoderClass === VOID) {
    class $ extends AbstractJsonTreeEncoder() {
      constructor(json, nodeConsumer) {
        return new.target.new_kotlinx_serialization_json_internal_JsonTreeListEncoder_ay6wlx_k$(json, nodeConsumer);
      }
      static new_kotlinx_serialization_json_internal_JsonTreeListEncoder_ay6wlx_k$(json, nodeConsumer) {
        var $this = this.new_kotlinx_serialization_json_internal_AbstractJsonTreeEncoder_90zv2p_k$(json, nodeConsumer);
        var tmp = $this;
        // Inline function 'kotlin.collections.arrayListOf' call
        tmp.array_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        return $this;
      }
      elementName_p66hrm_k$(descriptor, index) {
        return index.toString();
      }
      putElement_rnqfb1_k$(key, element) {
        var idx = toInt(key);
        this.array_1.add_dl6gt3_k$(idx, element);
      }
      getCurrent_z8uawt_k$() {
        return new (JsonArray())(this.array_1);
      }
    }
    initMetadataForClass($, 'JsonTreeListEncoder');
    JsonTreeListEncoderClass = $;
  }
  return JsonTreeListEncoderClass;
}
function _get_tag__e6h4qf($this) {
  var tmp = $this.tag_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('tag');
  }
}
var JsonTreeMapEncoderClass;
function JsonTreeMapEncoder() {
  if (JsonTreeMapEncoderClass === VOID) {
    class $ extends JsonTreeEncoder() {
      constructor(json, nodeConsumer) {
        return new.target.new_kotlinx_serialization_json_internal_JsonTreeMapEncoder_73hi4b_k$(json, nodeConsumer);
      }
      static new_kotlinx_serialization_json_internal_JsonTreeMapEncoder_73hi4b_k$(json, nodeConsumer) {
        var $this = this.new_kotlinx_serialization_json_internal_JsonTreeEncoder_wuszu5_k$(json, nodeConsumer);
        $this.isKey_1 = true;
        return $this;
      }
      putElement_rnqfb1_k$(key, element) {
        if (this.isKey_1) {
          var tmp = this;
          var tmp_0;
          if (element instanceof JsonPrimitive_2()) {
            tmp_0 = element.get_content_h02jrk_k$();
          } else {
            if (element instanceof JsonObject()) {
              throw InvalidKeyKindException(JsonObjectSerializer_getInstance().descriptor_1);
            } else {
              if (element instanceof JsonArray()) {
                throw InvalidKeyKindException(JsonArraySerializer_getInstance().descriptor_1);
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
          tmp.tag_1 = tmp_0;
          this.isKey_1 = false;
        } else {
          var tmp0 = this.content_1;
          // Inline function 'kotlin.collections.set' call
          var key_0 = _get_tag__e6h4qf(this);
          tmp0.put_4fpzoq_k$(key_0, element);
          this.isKey_1 = true;
        }
      }
      getCurrent_z8uawt_k$() {
        return new (JsonObject())(this.content_1);
      }
    }
    initMetadataForClass($, 'JsonTreeMapEncoder');
    JsonTreeMapEncoderClass = $;
  }
  return JsonTreeMapEncoderClass;
}
//region block: exports
export {
  writeJson as writeJson2mc74ohxvvl1i,
};
//endregion

//# sourceMappingURL=TreeJsonEncoder.mjs.map
